export const addNewOption = (fields, setFields) => {
  handleInputFields(fields, setFields);
};

export const removeAllOptions = (fields, setFields) => {
  if (fields.Type.toLowerCase() === "rating") {
    setFields({ ...fields, RadioButtonOptions: [] });
  } else if (fields.Type.toLowerCase() === "checkbox") {
    setFields({ ...fields, CheckBoxOptions: [] });
  }
};

export const handleInputFields = (fields, setFields) => {
  let newOptions = "";
  if (fields.Type.toLowerCase() === "rating") {
    newOptions = [...fields.RadioButtonOptions];
    for (
      let i = fields.RadioButtonOptions.length;
      i < fields.RadioButtonOptions.length + 1;
      i++
    ) {
      newOptions.push("");
    }
    setFields({ ...fields, RadioButtonOptions: newOptions });
  } else if (fields.Type.toLowerCase() === "checkbox") {
    newOptions = [...fields.CheckBoxOptions];
    for (
      let i = fields.CheckBoxOptions.length;
      i < fields.CheckBoxOptions.length + 1;
      i++
    ) {
      newOptions.push("");
    }
    setFields({ ...fields, CheckBoxOptions: newOptions });
  }
};

export const handleOptions = (value, index, fields, setFields, event) => {
  let newOptions = "";
  if (fields.Type.toLowerCase() === "rating") {
    const reg = new RegExp(/^\d+$/);
    const validateNumber = reg.test(value);
    if (validateNumber || value === "" || value === "d" || value === "dk") {
      const AllOptions = fields.RadioButtonOptions;
      const duplicateValue = AllOptions.filter((item) => {
        return item === value;
      });
      if (duplicateValue.length === 0 || value === "") {
        newOptions = [...fields.RadioButtonOptions];
        newOptions[index] = value;
        setFields({ ...fields, RadioButtonOptions: newOptions });
      }
    }
  } else if (fields.Type.toLowerCase() === "checkbox") {
    newOptions = [...fields.CheckBoxOptions];
    newOptions[index] = value;
    setFields({ ...fields, CheckBoxOptions: newOptions });
  }
};

export const handleRemove = (index, fields, setFields) => {
  let newOptions = [];
  let AllOptions = fields.RadioButtonOptions;
  if (fields.Type.toLowerCase() === "rating") {
    for (let i = 0; i < AllOptions.length; i++) {
      if (i !== index) {
        newOptions.push(AllOptions[i]);
      }
    }
    setFields({ ...fields, RadioButtonOptions: newOptions });
  } else if (fields.Type.toLowerCase() === "checkbox") {
    // this was an old condition which was comparing values not index
    //  newOptions = fields.CheckBoxOptions.filter(
    //   (option) => option !== fields.CheckBoxOptions[index]
    // );
    for (let i = 0; i < fields.CheckBoxOptions.length; i++) {
      if (i !== index) {
        newOptions.push(fields.CheckBoxOptions[i]);
      }
    }
    setFields({ ...fields, CheckBoxOptions: newOptions });
  }
};
